import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("aadvan_admin_token")) navigate("/admin");
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("aadvan_admin_token", data.token);
      localStorage.setItem("aadvan_admin_user", JSON.stringify(data.user));
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="font-serif text-4xl text-gold">Aadvan</div>
          <div className="text-xs tracking-[0.3em] uppercase text-cream/60">Admin Console</div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 space-y-4">
          <div className="flex items-center gap-2 text-forest mb-2"><Lock size={18} /><h1 className="font-serif text-2xl">Sign In</h1></div>
          <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="rounded-lg" required />
          <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="rounded-lg" required />
          <Button type="submit" disabled={loading} data-testid="admin-login-button" className="w-full bg-gold text-forest hover:bg-gold-soft rounded-full h-12 uppercase tracking-[0.15em] text-sm">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
